module.exports = __webpack_public_path__ + "img/logoTxt.05017d97.png";